<template>
  <section
    class="projects-section"
    style="background: linear-gradient(to bottom, #000 0%, #000 75%, #444 100%)"
  >
    <div class="container px-4 px-lg-5">
      <!-- Irish flutes (primary focus) -->
      <div class="row gx-0 mb-5 mb-lg-0 justify-content-center" id="flutes">
        <div class="col-lg-6">
          <div
            class="product-media h-100 d-flex align-items-center justify-content-center"
          >
            <img
              src="@/assets/img/products/flute-keyed-flatlay.jpg"
              class="product-img"
              alt="A keyed blackwood Irish flute, shown disassembled into its sections"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div
            class="bg-black text-center h-100 project"
            style="border-top: 0.4rem solid #f8b406"
          >
            <div class="d-flex h-100">
              <div
                class="project-text w-100 mx-auto my-auto text-center text-lg-left"
                style="max-width: 44rem"
              >
                <h4 class="text-white">irish flutes</h4>
                <p class="text-white-50">
                  Hand-turned wooden flutes in the Irish tradition, voiced by
                  hand for a warm, responsive tone all the way through.
                  Available keyless or keyed, with a configurable number of keys
                  (currently up to six) and a Rudall-style bore. My preferred
                  woods are grenadilla<CitesInfoComponent />
                  and olive; other woods are possible by arrangement.
                </p>
                <p class="mb-0">
                  <LinkComponent
                    link-text="Flute details"
                    href="/flutes"
                    :inverted="true"
                  />
                  <span class="text-white-50"> · </span>
                  <LinkComponent
                    link-text="contact me"
                    href="#contact"
                    :inverted="true"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Headjoints for Boehm flutes -->
      <div class="row gx-0 justify-content-center" id="headjoints">
        <div class="col-lg-6">
          <div
            class="product-media h-100 d-flex align-items-center justify-content-center"
          >
            <img
              src="@/assets/img/products/headjoint-in-flute.jpg"
              class="product-img"
              alt="A wooden panacoco headjoint fitted to a silver Boehm flute"
            />
          </div>
        </div>
        <div class="col-lg-6 order-lg-first">
          <div class="bg-black text-center h-100 project">
            <div class="d-flex h-100">
              <div
                class="project-text w-100 mx-auto my-auto text-center text-lg-right"
                style="max-width: 44rem"
              >
                <h4 class="text-white">boehm flute headjoints</h4>
                <p class="text-white-50">
                  Wooden headjoints for modern Boehm-system concert flutes — a
                  warmer, more colourful voice for your silver flute, without
                  replacing the instrument. Turned from the same woods as my
                  flutes (grenadilla<CitesInfoComponent />, olive, or others by
                  arrangement) featuring a CNC-cut embouchure with manual
                  finish, and fitted to your flute's tenon to your
                  specification.
                </p>
                <p class="mb-0">
                  <LinkComponent
                    link-text="Headjoint details"
                    href="/headjoints"
                    :inverted="true"
                  />
                  <span class="text-white-50"> · </span>
                  <LinkComponent
                    link-text="contact me"
                    href="#contact"
                    :inverted="true"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Whistles (still available on request) -->
      <div class="row gx-0 mb-5 mb-lg-0 justify-content-center" id="whistles">
        <div class="col-lg-6">
          <div
            class="product-media h-100 d-flex align-items-center justify-content-center"
          >
            <img
              src="@/assets/img/products/whistle-low-d.jpg"
              class="product-img"
              alt="A low D whistle in panacoco wood with aluminium sections"
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="bg-black text-center h-100 project">
            <div class="d-flex h-100">
              <div
                class="project-text w-100 mx-auto my-auto text-center text-lg-left"
                style="max-width: 44rem"
              >
                <h4 class="text-white">whistles</h4>
                <p class="text-white-50">
                  Whistles are where ironwood began, and I still build them on
                  request — in wood, aluminium and brass, tuned in just or equal
                  intonation, in every key. Thin-walled, tunable and voiced by
                  hand.
                </p>
                <p class="mb-0">
                  <LinkComponent
                    link-text="Whistle details"
                    href="/whistles"
                    :inverted="true"
                  />
                  <span class="text-white-50"> · </span>
                  <LinkComponent
                    link-text="contact me"
                    href="#contact"
                    :inverted="true"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import LinkComponent from "@/components/util/LinkComponent.vue";
import CitesInfoComponent from "@/components/general/CitesInfoComponent.vue";

export default defineComponent({
  name: "ProductsSectionComponent",
  components: { LinkComponent, CitesInfoComponent },
});
</script>

<style scoped>
.product-media {
  background: #fff;
  min-height: 20rem;
}
.product-img {
  max-width: 100%;
  max-height: 32rem;
  object-fit: contain;
}
</style>
